import React, { FC, Suspense, useEffect, useState } from 'react';
import { Container } from '../../symphony';
import { DynamicPaywallLoader } from './DynamicPaywallLoader';

// Lazy load the PaywallContainer
const LazyPaywallContainer = React.lazy(() =>
  import('../private/components/PaywallContainer/PaywallContainer').then(module => ({
    default: module.PaywallContainer
  }))
);

export const DynamicSlPaywall: FC = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const [paywallLoader] = useState(() => DynamicPaywallLoader.ensureRegistered());

  // Listen for paywall state changes
  useEffect(() => {
    let store: any = null;
    let subscription: any = null;

    // Function to setup subscription
    const setupSubscription = async () => {
      try {
        // Trigger loading of paywall services if not already loaded
        await paywallLoader.loadPaywallsService();

        // Get the store after it's loaded
        const { PaywallsStore } = await import('../private/paywalls.store');
        store = Container.take('paywalls', PaywallsStore);

        // Subscribe to paywall state changes
        subscription = store.paywallState.subscribe((state: any) => {
          setShouldRender(state === 'open'); // PaywallState.open === 'open'
        });
      } catch (error) {
        console.error('Failed to setup paywall subscription:', error);
      }
    };

    setupSubscription();

    return () => {
      if (subscription) {
        subscription.unsubscribe();
      }
    };
  }, [paywallLoader]);

  // Don't render anything if paywall should not be shown
  if (!shouldRender) {
    return null;
  }

  return (
    <Suspense fallback={<div style={{ display: 'none' }} />}>
      <LazyPaywallContainer />
    </Suspense>
  );
}; 